import { Button, Img, Text, Heading } from "../../components";
import React from "react";
import { Link } from 'react-router-dom';

export default function LandingpagewipCtawaitlist() {
  return (
    <div className="relative z-[2] flex items-end justify-center bg-[url(/public/images/img_cta_waitlist.svg)] bg-cover bg-no-repeat py-[90px] md:h-auto md:py-5">
      <div className="container-xs mt-[38px] flex justify-center px-14 md:px-5 sm:h-[400px]">
        <div className="flex w-full flex-col items-center gap-5 sm:gap-10">
          <div className="flex flex-col items-center self-stretch px-[46px] sm:px-5">
            <Heading
              size="headingmd"
              as="h2"
              className="text-[48px] font-bold !text-white text-center md:text-[44px] sm:text-[32px] sm:leading-[100%] sm:text-center"
            >
              Not ready to buy? Get early access instead!
            </Heading>
            <Text as="p" className="self-stretch text-center text-[20px] font-normal !text-white">
              Curious but not ready to commit? Be the first to access Lifetoon and turn your moments into unforgettable
              comics. Get exclusive perks & early-bird discounts!
            </Text>
          </div>
          <Link to="/formnew">
          <div className="flex h-[7vw] min-h-[fit-content] items-center justify-center md:h-[100px]">
            <Button
              size="lg"
              rightIcon={
                <Img
                  src="images/img_arrowright.svg"
                  alt="Arrow Right"
                  className="mb-1 mt-0.5 h-[32px] w-[32px] object-contain transition-all duration-300 ease-in-out"
                />
              }
              className="gap-1.5 rounded-[30px] px-[30px] py-2 font-medium italic shadow-md sm:px-5 
             bg-orange_accent1 text-dark_blue_secondary
             border-2 border-solid border-dark_blue_secondary border-b-8
             hover:bg-yellow-200 hover:border-0 hover:text-dark_blue_secondary
             transition-all duration-300 ease-in-out sm:min-w-[280px] sm:px-4 sm:text-[14px] sm:py-2"
            >
              Join the waitlist today
            </Button>
          </div>
      </Link>
        </div>
      </div>
    </div>
  );
}
